import { IsEmail, IsNotEmpty } from 'class-validator';

export class MinisiteEmailFormData {
    @IsEmail()
    @IsNotEmpty()
    email: string;
}
